import reportService from './ReportService/ReportService';
import userService from './UserService/UserService';

const api = {
  reportService,
  userService,
};

export default api;
